import { render, staticRenderFns } from "./BeautyTokenGuidePopup.vue?vue&type=template&id=b2cf1610&scoped=true&"
import script from "./BeautyTokenGuidePopup.vue?vue&type=script&lang=js&"
export * from "./BeautyTokenGuidePopup.vue?vue&type=script&lang=js&"
import style0 from "./BeautyTokenGuidePopup.vue?vue&type=style&index=0&id=b2cf1610&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cf1610",
  null
  
)

export default component.exports